import { observable, configure, action } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class ConsumerStore extends StoreModel {
    constructor() {
        super('consumer', {
            namePlural: 'consumers',
            sort: '-updatedDate',
            api: {
                search: {
                    url: '/api/consumers/',
                    params: {},
                },
                load: {
                    url: '/api/consumers/admin/',
                    params: {},
                },
                save: {
                    url: '/api/consumers/',
                    params: {},
                },
                delete: {
                    url: '/api/consumers/admin/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable consumer = {};

    @observable consumeres = [];

    @observable deleted = {};

    @action
    markDeleted(id) {
        this.deleted[id] = true;
    }

    @action
    async removeRod(consumerId, serial) {
        await util.fetchApi(
            `/api/consumers/admin/${consumerId}/rods/${serial}`,
            { method: 'DELETE' },
        );
        const consumer = this.consumers.find(c => c.id === consumerId);
        if (consumer && consumer.rods) {
            delete consumer.rods[serial];
        }
    }
}

const store = new ConsumerStore();
export default store;



// WEBPACK FOOTER //
// ./stores/consumer.js